// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"28a4e9e9","300":"5782e70e","419":"7b5b5bc0","698":"f15174a6"}[chunkId] + ".chunk.js";
};